import React from 'react';
import { common } from '@kurtosys/ksys-app-template';
import Box from '@mui/material/Box/Box.js';
import Tab from '@mui/material/Tab/Tab.js';
import MuiTabs from '@mui/material/Tabs/Tabs.js';

import { AppStore } from '../App/stores/AppStore.js';
import { useMuiStyles } from '../hooks/useMuiStyles.js';
import { useStores } from '../hooks/useStores.js';

import { IAppTabComponent } from './models/IAppTabComponent.js';
import { IAppTabsStyle } from './models/IAppTabsStyle.js';
import { IMuiTabOptions } from './models/IMuiTabOptions.js';
const isNullOrEmpty = common.commonUtils.isNullOrEmpty;

export interface ITabsProps {
	activeIndex: number;
	handleChange?: (newValue: number) => void;
	items?: IAppTabComponent[];
	children?: React.ReactNode;
	getLabel: (header: string) => string;
	options: IMuiTabOptions;
}

export const Tabs: React.FC<ITabsProps> = ({ activeIndex, handleChange, items, children, getLabel, options }) => {
	const styles = useMuiStyles('tabs') as IAppTabsStyle;
	const appStore = useStores<AppStore>('appStore');
	const { appLevelGuid } = appStore;

	const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
		handleChange(newValue);
	};

	const a11yProps = (index: number) => {
		return {
			id: `tab-${index}`,
			'aria-controls': `${appLevelGuid}-tabpanel-${index}`,
		};
	};

	return (
		<>
			<Box className={`tabs-container`} sx={styles?.tabsContainer?.styles}>
				<MuiTabs
					textColor="inherit"
					indicatorColor="secondary"
					value={activeIndex}
					onChange={handleTabChange}
					aria-label="Tabs"
					{...options}
					TabIndicatorProps={{
						sx: styles?.tabsContainer?.tabIndicator?.styles,
					}}
				>
					{items?.map(({ tabKey, header, icon }, index) => {
						const label = getLabel(header);
						return (
							<Tab
								className="tabs-tab"
								sx={styles?.tabsContainer?.tab?.styles}
								TouchRippleProps={{ hidden: true }}
								key={`tab-header-${tabKey}`}
								label={label}
								icon={
									icon && (
										<img
											width={20}
											aria-hidden={isNullOrEmpty(label) || true}
											src={icon.asset}
											alt={`${icon.alt} ${tabKey}`}
											style={styles?.tabsContainer?.tab?.icon?.styles}
										/>
									)
								}
								iconPosition={icon?.align || 'end'}
								{...a11yProps(index)}
							/>
						);
					})}
				</MuiTabs>
			</Box>
			{children}
		</>
	);
};
